import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import {
  getAlertStatus,
  getIsRecentlyAdded,
  getIsReservableVehicle
} from '~/selectors';
import {
  LockedBadge,
  OnHoldBadge,
  PreOrderBadge,
  RecentlyAddedBadge
} from '../../Badges';

type OwnProps = Omit<React.HTMLProps<HTMLDivElement>, 'ref'>;

export default function HeroBadge(props: OwnProps) {
  const { isInitialized, shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useSelector(getAlertStatus);
  const isReservable = useSelector(getIsReservableVehicle);
  const isRecentlyAdded = useSelector(getIsRecentlyAdded);

  switch (true) {
    case !isInitialized:
      return null;
    case purchasePending && shouldShowTimer:
      return <OnHoldBadge {...props} />;
    case purchasePending:
      return <LockedBadge {...props} />;
    case isReservable:
      return <PreOrderBadge {...props} />;
    case isRecentlyAdded:
      return <RecentlyAddedBadge {...props} />;
    default:
      return null;
  }
}
